import { motion, useAnimation, useReducedMotion } from 'framer-motion';
import { useRef } from 'react';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { site } from '../../config/site';

export const Logo = ({ location = 'header' }) => (
  <a href="/" className="brand-link" aria-label="Cortis homepage" data-testid={`${location}-logo-link`}>
    <img src="/brand/cortis-logo.svg" alt="cortis" width="572" height="158" data-testid={`${location}-logo`} />
  </a>
);

export const AppLink = ({ location, className = '', children = 'Open Cortis' }) => (
  <Button asChild className={`action-link solid ${className}`}>
    <a href={site.app} data-testid={`${location}-app-link`}>{children}<ArrowUpRight aria-hidden="true" size={18} /></a>
  </Button>
);

export const PaperLink = ({ location, children = 'Read the white paper', className = '' }) => (
  <Button asChild variant="outline" className={`action-link outlined ${className}`}>
    <a href={site.whitepaper} data-testid={`${location}-whitepaper-link`}>{children}<ArrowUpRight aria-hidden="true" size={17} /></a>
  </Button>
);

export const TextLink = ({ href, children, testId, ...props }) => (
  <a className="text-link" href={href} data-testid={testId} {...props}>{children}<ArrowRight size={16} aria-hidden="true" /></a>
);

export const Chapter = ({ number, children, id }) => (
  <div className="chapter" data-testid={`${id}-chapter`}><span aria-hidden="true">{number}</span><span>{children}</span></div>
);

export const Section = ({ children, className = '', id, ...props }) => {
  const controls = useAnimation();
  const reduced = useReducedMotion();
  const revealed = useRef(false);
  return <motion.section id={id} className={`section ${className}`} initial={false} animate={controls}
    viewport={{ once: true, amount: 0.08 }}
    onViewportEnter={() => {
      if (revealed.current || reduced) return;
      revealed.current = true;
      controls.start({ opacity: [0.55, 1], y: [18, 0], transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } });
    }} data-testid={`${id}-section`} {...props}>{children}</motion.section>;
};